module.exports = __webpack_public_path__ + "assets/lost-a78fc1.mp3";